module.exports = __webpack_public_path__ + "img/PM_A02_front_cross_diagonal_en.7775d5d7.png";